export { default } from './Col'